import {
  SingleSelectFromInfiniteQuery,
  SingleSelectFromInfiniteQueryProps,
} from "./SingleSelectFromInfiniteQuery"
import { useTranslation } from "react-i18next"
import {
  InfiniteData,
  UseSuspenseInfiniteQueryResult,
} from "@tanstack/react-query"
import { getSimplePersons, GetSimplePersonsParams } from "@/orval/gen"
import { SimplePersonPagination } from "@/orval/gen/model"
import { fetchSimplePersonById } from "@/-dataloaders/simple-persons"
import { useDefaultInfiniteQuery } from "@/utils/useDefaultInfiniteQuery"

interface Props extends Omit<
  SingleSelectFromInfiniteQueryProps<
    UseSuspenseInfiniteQueryResult<InfiniteData<SimplePersonPagination>>
  >,
  "queryData" | "entitiesToComboboxData"
> {
  filterOptions?: Omit<
    GetSimplePersonsParams,
    "pageParam" | "pageSize" | "searchValue"
  >
}

export function InfinitePersonSingleSelect({
  filterOptions = {},
  ...props
}: Props) {
  const { t } = useTranslation("app_server")
  const [searchValue, setSearchValue] = React.useState("")

  return (
    <SingleSelectFromInfiniteQuery
      searchValue={searchValue}
      onSearchChange={setSearchValue}
      entitiesToComboboxData={(person) => ({
        label: person.name ?? "",
        value: person.personId?.toString() ?? "",
      })}
      label={t("Contacts")}
      placeholder={t("SearchContact")}
      noOptionsFoundText={t("NoContactsFound")}
      {...props}
      queryData={useDefaultInfiniteQuery(getSimplePersons, (pageRequest) => ({
        ...pageRequest,
        searchValue,
        ...filterOptions,
      }))}
      fetchSelectedItem={fetchSimplePersonById}
      getSelectedItemQueryKey={(id) => ["SimplePerson", parseInt(id, 10)]}
    />
  )
}
